import { ApiService } from './../api/api.service';
import { UtilityCookieService as utilityCookie } from './../../utils/cookie/utilitycookie.service';
import { StorageService } from './../storage/storage.service';
import { ConfigService } from './../../config/config/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/api.service";
import * as i2 from "../storage/storage.service";
import * as i3 from "../../config/config/config.service";
var CoreService = /** @class */ (function () {
    function CoreService(apiService, storage, config) {
        this.apiService = apiService;
        this.storage = storage;
        this.config = config;
    }
    CoreService.prototype.prefetchRxHistory = function (forceCacheFlush) {
        if (forceCacheFlush === void 0) { forceCacheFlush = false; }
        var icec = utilityCookie.getCookie(this.config.get('cacheCookieName'));
        var hrUnit = 1000 * 60 * 60;
        if (icec) {
            var lastPrefetch = this.storage.get('lastPrefetch', this.storage.sessionStorage) || (new Date().getTime() + (hrUnit * 21));
            // prefetch once a day ~ 20 hrs
            if ((lastPrefetch - new Date().getTime() > (hrUnit * 20))) {
                this.prefetch(icec, forceCacheFlush).subscribe(function (r) {
                }, function (err) {
                }, function () {
                });
                this.storage.set('lastPrefetch', new Date().getTime(), this.storage.sessionStorage);
            }
        }
    };
    /**
     * Send request to server to prefetch data from resources
     */
    CoreService.prototype.prefetch = function (icecCookie, forceCacheFlush) {
        if (forceCacheFlush === void 0) { forceCacheFlush = false; }
        if (icecCookie) {
            var queryParams = this.apiService.getDefaultQueryParams('prefetchRxStatusSummary', 'prefetchRxStatusSummary', false);
            var request = {
                request: {
                    'header': {
                        appName: queryParams['appName'],
                        deviceType: queryParams['deviceType'],
                        channelName: queryParams['channelName'],
                        lineOfBusiness: queryParams['lineOfBusiness'],
                        deviceToken: queryParams['deviceToken'],
                        apiKey: queryParams['apiKey'],
                        source: queryParams['source'],
                        responseFormat: 'JSON',
                        securityType: 'apiKey'
                    }, prefetchRxStatusSummaryInfo: {
                        idValue: icecCookie.icec || icecCookie, idType: 'Retail', forceCacheFlush: false
                    }
                }
            };
            if (forceCacheFlush) {
                request.request.prefetchRxStatusSummaryInfo.forceCacheFlush = true;
            }
            return this.apiService.post('prefetchRxSummary', {}, request, { withOAuth: true });
        }
    };
    CoreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CoreService_Factory() { return new CoreService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.StorageService), i0.ɵɵinject(i3.ConfigService)); }, token: CoreService, providedIn: "root" });
    return CoreService;
}());
export { CoreService };
